import { getDataDependency } from 'gandi.react-helpers';
export var makeWrapHandler = function makeWrapHandler(Wrapped, Hoisted, getWrapper) {
  return function (handlerName) {
    // Call child preFetch and other handlers if any
    var wrappedHandler = getDataDependency(Wrapped, handlerName);

    if (!wrappedHandler) {
      return;
    } // eslint-disable-next-line no-param-reassign


    Hoisted[handlerName] = getWrapper(wrappedHandler);
  };
};